export default {
  data() {
    return {
      validPhone: false,
      internationalInputOptions: {
        placeholder: "",
        // showDialCode: true,
      },
      validationsPhone: {
        phone1: true,
        phone2: true,
        api_followup_phone: true,
      },
      iso2: undefined,
    };
  },
  methods: {
    phoneObject(object, variable) {
      if (Object.keys(object).length !== 0) {
        if (object.valid) {
          this.validationsPhone[variable] = true;
          this.validPhone = true;
          this.getCustomerRate(this.orderData.phone1);
        } else {
          this.validationsPhone[variable] = false;
          this.validPhone = false;
          this.showCustomerRate = false;
          this.customerRateData = null;
        }
      }
    },
    returnDefaultCountry(phone) {
      let code = phone;
      if (code) {
        if (code.startsWith(966)) {
          return 966;
        } else {
          return 218;
        }
      }
    },
    formatNumberPhone(data, phone) {
      if (this[data][phone]) {
        if (this[data][phone].includes("+218")) {
          this[data][phone] = this[data][phone].replace("+218", "0");
          this[data][phone] = this[data][phone].replace(/\s/g, "");
        }
      }
    },
    isAutoFormat(data,phone) {
      if (!this[data][phone]) {
        return true; // default to true if phone number is not set
      }
      // Check if the selected country is 'LY' based on the phone number prefix
      return this.getCountryCodeFromPhone(this[data][phone]) !== 'LY';
    },
    getCountryCodeFromPhone(phoneNumber) {
      const libyanPrefixes = ['091', '092', '093' , '094','095'];
      const prefix = phoneNumber.substring(0, 3);
      if (libyanPrefixes.includes(prefix)) {
        return 'LY';
      }
      return '';
    }
  },
};
